import { envVariables } from './dot-env';
import { convertToURLSearchParams } from './search-params';

/**
 * Fetch data from the falck.dk API
 * @arg { string | URL | globalThis.Request } url - The URL to fetch data from
 * @arg {RequestInit} config - The configuration object
 * @arg {object} config.params - The query parameters to add to the URL
 */
export async function fetchFalckdkApi(url, config) {
    const searchParams = convertToURLSearchParams(config?.params).toString();
    const urlWithParams = searchParams ? `${url}?${searchParams}` : url;

    try {
        return fetch(urlWithParams, {
            ...config,
            headers: {
                'Content-Type': 'application/json',
                ...config.headers,
                'X-API-Key': envVariables.falckdkApiKey,
            },
            body: JSON.stringify(config.body),
        });
    } catch (error) {
        console.error('Fetch error:', error);

        throw error;
    }
}
